<template><div><h1 id="zusagen-betrage" tabindex="-1"><a class="header-anchor" href="#zusagen-betrage"><span>Zusagen-Beträge</span></a></h1>
<p>Zusagen-Beträge — Definiert Zusagen-Beträge</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Tabelle ermöglicht das Festlegen von fixen Beträgen für eine bestimmte Zusage. Wird bei einer Zusage kein versprochener Betrag erfasst, so nimmt das System die Werte aus dieser Tabelle. Bei der Zusagenfakturierung wird dann anhand der eingegebenen Kriterien der definierte Betrag fakturiert.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Zusagen → Zusagen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Zusage</dt>
<dd><a class="link" href="ft.refdata.tblzusart.html" title="Zusagen">Zusageart</a></dd>
<dt>Inland/Ausland</dt>
<dd>Inland oder Ausland</dd>
<dt>bis Alter</dt>
<dd>Altersbegrenzung</dd>
<dt>Personenmerkmal</dt>
<dd><a class="link" href="ft.refdata.tbladrmerkmal.html" title="Personenmerkmal">Personenmerkmal</a></dd>
<dt>Betrag</dt>
<dd>Betrag der Zusage</dd>
<dt>Raten</dt>
<dd>Anzahl Raten, in denen der eingegebene Betrag bezahlt werden soll</dd>
<dt>Zusagentyp</dt>
<dd><a class="link" href="ft.refdata.tblzustyp.html" title="Zusagentypen">Auswahl des Zusagentyps</a></dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
</div></template>


